import React from 'react';
var ThreeQuarters = function () {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "58px", height: "6px", viewBox: "0 0 58 6", version: "1.1", role: "img" },
        React.createElement("title", null, "Progress Three Quarters"),
        React.createElement("desc", null, "ThreeQuarters progress."),
        React.createElement("defs", null),
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { d: "M44,0 L57.5,0 C57.7761424,9.30328261e-16 58,0.223857625 58,0.5 L58,5.5 C58,5.77614237 57.7761424,6 57.5,6 L44,6 L44,0 Z", id: "Rectangle", fill: "#CCCCCC" }),
                React.createElement("path", { d: "M0.5,0 L44,0 L44,6 L0.5,6 C0.223857625,6 3.38176876e-17,5.77614237 0,5.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z", id: "Rectangle", fill: "#0073EC" })))));
};
export default ThreeQuarters;
